import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./ImageZoomModal.css";

function ImageZoomModal({ open, onClose, src, alt, loading = false, error = "" }) {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);
    closeButtonRef.current?.focus();

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      className="modificaProdottiImmagineZoomBackdrop sfondoOverlayTema"
      onMouseDown={onClose}
      role="presentation"
    >
      <div
        className="modificaProdottiImmagineZoomDialog sfondoBiancoTema br3 shadow-5"
        role="dialog"
        aria-modal="true"
        aria-label={alt}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button
          ref={closeButtonRef}
          type="button"
          className="modificaProdottiImmagineZoomClose"
          onClick={onClose}
          aria-label="Chiudi immagine ingrandita"
          title="Chiudi"
        >
          ×
        </button>
        {loading && <p className="ma0 pa4 tc">Caricamento immagine originale…</p>}
        {!loading && error && <p className="ma0 pa4 tc dark-red">{error}</p>}
        {!loading && !error && src && (
          <img className="modificaProdottiImmagineZoomFull" src={src} alt={alt} />
        )}
      </div>
    </div>,
    document.body,
  );
}

export default ImageZoomModal;
